var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mpv-tooltip-with-icon"},[_c('i',{class:("mpv-tooltip-with-icon-fig " + (_vm.icon ? _vm.icon : 'fa fa-question-circle'))}),_vm._v(" "),_c('span',{class:("tooltip-with-icon-text " + (_vm.standalone ? 'standalone' : ''))},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9fa65ef6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ui/TooltipIcon.vue
// module id = null
// module chunks = 